import { existsSync, mkdirSync, writeFileSync } from "node:fs";

import trash from "trash";

import { errorMessages } from "@/src/utils/errors.ts";
import { logger } from "@/src/utils/logger.ts";

/**
 * @description Create folder, checking also if it already exists
 */
export function createFolder(dir: string) {
  try {
    if (!dir) {
      throw errorMessages.undefinedCreateFolderDir();
    }
    if (!existsSync(dir)) {
      mkdirSync(dir, { recursive: true });
    }
  } catch (error) {
    logger.error(error);
  }
}

/**
 * @description Refresh a folder by trashing it first, then creating a new folder
 */
export const refreshFolder = async (path: string) => {
  try {
    if (!path) {
      throw errorMessages.undefinedRefreshPath();
    }
    await trash([path]);
    createFolder(path);
  } catch (error) {
    logger.error(error);
  }
};

/**
 * @description Helper that writes files. Prefer using the writeFile function since that is hooked up for any pre-processing.
 */
export function writeFile(filePath: string, fileContent: string | Buffer) {
  try {
    if (!filePath || !fileContent) {
      throw errorMessages.writingFile();
    }
    writeFileSync(filePath, fileContent, "utf8");
  } catch (error) {
    logger.error(error);
  }
}
